import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/panel/app/components/HelpChat/HelpChatWidget.tsx");
